import { THEME_CLASSIC } from './themes/classic/theme';
import { THEME_DEFAULT } from './themes/default/theme';
import { THEME_CELESTIAL } from './themes/celestial/theme';

export const THEME = {
    CLASSIC: THEME_CLASSIC,
    DEFAULT: THEME_DEFAULT,
    CELESTIAL: THEME_CELESTIAL
};
